<script setup>
import FordButton from '@/components/FordButton.vue';
import EventSection from './EventSection.vue';

defineProps({
  event: Object,
  firstName: String,
});

const emit = defineEmits(['close']);

const closeModal = () => emit('close');
</script>
<template>
  <div class="tablet:text-center">
    <div>
      <h1 class="
        text-[1.125rem] tablet:text-[2.125rem]
        font-FordAntennaMed
        mb-[1.875rem]
        max-w-[53rem]
        mx-auto
      ">
        Thank you, {{ firstName }}!
      </h1>
      <p
        class="
          text-[.875rem] tablet:text-[1rem]
          text-ford-gray-darker
          mb-[1.875rem]
        ">
        Your appointment has been scheduled.<br/>
        The Ford Pro™ team looks forward to meeting with you.</p>
      <ford-button
        class="
          mb-[3rem]
        "
        transparent
        @method="closeModal">Close</ford-button>
    </div>
    <hr class="
      mx-auto
      max-w-[50rem]
      mb-[2.5rem] hidden tablet:block
    " />
    <event-section :event="event" />
  </div>
</template>
